(function (document, $, Coral) {
  "use strict";
  $(document).on("foundation-contentloaded", function (e) {
    $(".cmp-list__editor coral-select.select-for-image ", e.target).each(function (i, element) {
      Coral.commons.ready(element, function (component) {
        component.on("change", function (event) {
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          showHideImage(component, event);
        });

        setTimeout(() => {
          component.trigger("change");
        }, "50");
      });
    });
  });

  const showHideImage = function (component, event) {
    const optionSelected = component.querySelector("coral-select-item[value=" + event.target.value + "]");
    const srcImage = optionSelected.getAttribute("data-srcimage");
    const containerForImage = document.querySelector(".cmp-list__editor .container-for-image");
    if (containerForImage.innerHTML != "") {
      if (srcImage != "" && srcImage != undefined) {
        const coralCardAsset = containerForImage.querySelector("coral-card-asset img[src]");
        coralCardAsset.setAttribute("src", srcImage);
      } else {
        containerForImage.addClass = "hide";
      }
    } else {
      if (srcImage != "" && srcImage != undefined) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        containerForImage.innerHTML = generateCoralCard(srcImage);
      }
    }
  };
  const generateCoralCard = function (imageUrl) {
    return (
      '<div class="aem-image-preview-card">' +
      '<coral-card fixedwidth assetwidth="200" assetheight="200">' +
      '<coral-card-asset><img style="opacity: 1;" width="100" height="100" src="' +
      imageUrl +
      '"></coral-card-asset>' +
      "<coral-card-content>" +
      "</coral-card-content>" +
      "</coral-card>" +
      "</div>"
    );
  };
})(document, window.Granite.$, window.Coral);
